var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDogs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "binancecoin"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_51",
    "data-name": "Layer 51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 30,
    height: 30,
    rx: 7
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8.49,6.83a3.62,3.62,0,0,1,2.33.88c.5.4,1,.83,1.46,1.25a.42.42,0,0,0,.37.11c.53-.1,1.07-.2,1.61-.28L15,8.7a2.2,2.2,0,0,1,.36,0,8.51,8.51,0,0,1,1,.16,1.82,1.82,0,0,0,1,0A9.43,9.43,0,0,0,19,8.05a16.69,16.69,0,0,1,2.38-1.13A4.07,4.07,0,0,1,23,6.64a2.57,2.57,0,0,1,1.65.74A1.31,1.31,0,0,1,25,8.79a3.68,3.68,0,0,1-1.83,2.35q-.74.42-1.5.78a1,1,0,0,0-.64.77l-.39,1.86c-.18.93-.34,1.86-.52,2.79a21,21,0,0,1-.82,3,10.68,10.68,0,0,1-1.4,2.78,5.07,5.07,0,0,1-2.08,1.76,4.53,4.53,0,0,1-1.45.35,1.49,1.49,0,0,1-.85-.23A4.16,4.16,0,0,1,12,23.58a9.36,9.36,0,0,1-.6-1.28,6.59,6.59,0,0,1-.52-2.67c0-.36-.06-.71-.08-1.06s-.09-.94-.12-1.4a11,11,0,0,0-.32-1.8c-.29-1.14-.57-2.29-.86-3.43a.84.84,0,0,0-.22-.39c-.32-.31-.66-.58-1-.87s-.6-.52-.86-.8a1.94,1.94,0,0,1-.36-2.17,1.2,1.2,0,0,1,1.3-.88ZM12.68,23c0,.09,0,.21,0,.33a1.38,1.38,0,0,0,.4.87,1.44,1.44,0,0,0,1,.37,2.82,2.82,0,0,0,2.23-.9,1.82,1.82,0,0,0,.29-2.12,2.15,2.15,0,0,0-2.19-1,2,2,0,0,0-1.48,1.15A3.51,3.51,0,0,0,12.68,23ZM18,16.56l.28,0a.72.72,0,0,0,.48-.31,2,2,0,0,0,.39-1.42c0-.16-.09-.32-.1-.49a2,2,0,0,0-.45-1,1,1,0,0,0-.58-.38.93.93,0,0,0-.82.22,2.62,2.62,0,0,0-1,2.15,1.07,1.07,0,0,0,.7,1.07A3.92,3.92,0,0,0,18,16.56Zm-4.48-1.84a1.52,1.52,0,0,0-.25-.88,1,1,0,0,0-1.78.07,1.62,1.62,0,0,0,0,1.44,1,1,0,0,0,1.54.42A1.33,1.33,0,0,0,13.53,14.72ZM20.15,9,20,8.88a.23.23,0,0,0-.35.06.28.28,0,0,1-.28.16l-.43,0a.21.21,0,0,0-.18.17s.07.09.12.14a1,1,0,0,1,.21.19c.12.16.07.3-.12.36a1.2,1.2,0,0,1-.33.06c-.11,0-.13,0-.09.15a.34.34,0,0,0,.33.24.17.17,0,0,1,.17.13c.06.19.17.23.34.16a.32.32,0,0,0,.18-.29c0-.16,0-.31,0-.46s.12-.42.39-.45l.17,0-.23-.27Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDogs);
export default __webpack_public_path__ + "static/media/dogs.37d5a2a6e7a7317f9cd331ccf2208bc8.svg";
export { ForwardRef as ReactComponent };